import { formItemLayout } from "SuperAdmin/Config/FormLayout";
import { ImageType } from "SuperAdmin/Config/ImageType";
import {
  facultyProfilePermissions,
  unitPermissions,
} from "SuperAdmin/Config/Permissions";
import { Button, Checkbox, Form, Input, Tag } from "antd";
import styles from "./Form.module.scss";

const FormUpdateRole = ({ form, type, onFinishForm }) => {
  return (
    <div className={styles["update-role-form"]}>
      <Form
        {...formItemLayout}
        form={form}
        onFinish={onFinishForm}
        layout="vertical"
      >
        <Form.Item
          rules={[
            {
              required: true,
            },
          ]}
          label={"Name:"}
          labelAlign="left"
          name="name"
        >
          <Input placeholder="Please input the name" />
        </Form.Item>
        <Form.Item
          rules={[
            {
              required: true,
            },
          ]}
          label={"Type:"}
          labelAlign="left"
          name="type"
        >
          <Tag color={form.getFieldValue("type") === 1 ? "green" : "purple"}>
            Type {form.getFieldValue("type")} -{" "}
            {form.getFieldValue("type") === 1 ? "Institution" : "Unit"}
          </Tag>
        </Form.Item>
        <Form.Item
          rules={[
            {
              required: true,
            },
          ]}
          label={"Management scope:"}
          labelAlign="left"
          name="management_scope_id"
        >
          {type == 1 ? (
            <div className={styles["management-scope-item"]}>
              <div className={styles["management-scope"]}>
                <img
                  src={`https://media.academic.online/institutions_images/${form.getFieldValue(
                    "institution_id"
                  )}/${ImageType.THUMBNAIL}.png`}
                  alt="avatar"
                  classname={styles["photo"]}
                />
              </div>
              <div className={styles["management-scope-info"]}>
                <p className={styles["management-scope-name"]}>
                  {form.getFieldValue().management_scope_name}
                </p>
              </div>
            </div>
          ) : (
            <div className={styles["management-scope-item"]}>
              <div className={styles["management-scope"]}>
                <img
                  src={`https://media.academic.online/institutions_images/${form.getFieldValue(
                    "institution_id"
                  )}/${ImageType.THUMBNAIL}.png`}
                  alt="avatar"
                  classname={styles["photo"]}
                />
              </div>
              <div className={styles["management-scope-info"]}>
                <p className={styles["management-scope-name"]}>
                  {form.getFieldValue().management_scope_name}
                </p>
                <p>{form.getFieldValue("institution_name")}</p>
              </div>
            </div>
          )}
        </Form.Item>

        <Form.Item
          style={{ display: "none" }}
          name="management_scope_name"
        ></Form.Item>
        <Form.Item
          rules={[
            {
              required: true,
            },
          ]}
          label={"Unit permissions:"}
          labelAlign="left"
          name="unit_permissions"
        >
          <Checkbox.Group
            options={unitPermissions}
            defaultValue={unitPermissions[0].value}
          />
        </Form.Item>
        <Form.Item
          rules={[
            {
              required: true,
            },
          ]}
          label={"Faculty profile permissions:"}
          labelAlign="left"
          name="faculty_profile_permission"
        >
          <Checkbox.Group
            options={facultyProfilePermissions}
            defaultValue={facultyProfilePermissions[0].value}
          />
        </Form.Item>
        <div className={styles["update-button"]}>
          <Button htmlType="submit" type="primary">
            Update
          </Button>
        </div>
      </Form>
    </div>
  );
};

export default FormUpdateRole;
